import React, {useEffect, useState} from 'react';
import _ from "lodash";
import AddEditCampaign from "./add-edit-campaign";
import CampaignFilters from "./campaign-filters";
import {searchCampaignsWithSearchCriteria} from "../../services/facebook-campaign-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {CAMPAIGN_DESIGN_INFO_FIELDS_LIST, CAMPAIGN_FIELDS_LIST} from "../../constants/campaign.constant";
import GoToLink from "../../../common/ui/go-to-link";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import DesignDetailTable from "../../../design/components/publisher/design-detail-table";
import SearchTargetingInterest from "../targeting/search-targeting-interest";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {PARENT_PRODUCT_DETAIL_TABS_LIST} from "../../../pod/constants/pod.constant";
import CampaignDesignDetail from "./campaign-design-detail";
import {getSingleDesignById} from "../../../design/services/design-data-service";

const tabsList = PARENT_PRODUCT_DETAIL_TABS_LIST;

const CampaignDesigns = ({
                             designInfoList,
                             parentProduct,
                             parentProductSearchInterestList,
                             campaign,
                             campaignInterests,
                             setCampaignInterests
                         }) => {
    const [initialStep, setInitialStep] = useState(true);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(false);
    const [selectedDesignInfo, setSelectedDesignInfo] = useState(null);
    const [designDetail, setDesignDetail] = useState(null);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            setSelectedDesignInfo(designInfoList?.[0]);
        }
    }, [initialStep]);

    useEffect(() => {
        if (selectedDesignInfo) {
            getDesignDetail(selectedDesignInfo?.id);
        }
    }, [selectedDesignInfo?.id]);

    const getDesignDetail = async (designId) => {
        const designDetailResult = await getSingleDesignById(designId);
        setDesignDetail(designDetailResult);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2 mr-4'}>
                        Designs
                    </div>

                    {/*<div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>*/}
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    <div className="ml-2">

                    </div>
                </div>

            </div>

            <div className="flex justify-start mt-4">

                <div className="w-1/4">

                    <div
                        className={'table-container-with-title-2 bg-white overflow-y-scroll border border-gray-400 rounded-lg'}>

                        <ShowEmptyListMessage
                            dataList={designInfoList}
                            dataFetchInProgress={false}
                            label={'Designs'}/>

                        {designInfoList?.length > 0 &&
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 w-8">S.No</th>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 text-left">Name</th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {designInfoList?.map((designInfo, rowIndex) => (
                                    <tr key={`row-${rowIndex}`}
                                        onClick={() => {
                                            setSelectedDesignInfo(designInfo);
                                        }}
                                        className={`border-b border-gray-400 cursor-pointer hover:bg-green-100 ${(selectedDesignInfo && selectedDesignInfo?.id === designInfo?.id) ? 'bg-green-200' : ''}`}>
                                        <td className="p-2 m-auto">
                                            <div className="flex justify-center w-8">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        <td className={`p-2 m-auto flex justify-start items-center`}>
                                            <div className={'mr-4'}>
                                                {designInfo?.name}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        }

                    </div>

                </div>

                <div className={'w-3/4'}>

                    {selectedDesignInfo &&
                        <CampaignDesignDetail
                            parentProductSearchInterestList={parentProductSearchInterestList}
                            parentProduct={parentProduct}
                            designDetail={designDetail}
                            campaign={campaign}
                            designInfo={selectedDesignInfo}
                            campaignInterests={campaignInterests}
                            setCampaignInterests={setCampaignInterests}/>
                    }
                </div>

            </div>

        </>
    )
}

export default CampaignDesigns
